import React, { useState } from "react";
import BackButton from "../BackButton/BackButton";
import BackDrop from "../BackDrop/BackDrop";
import OptionsButton from "../OptionsButton/OptionsButton";
import ProfileButton from "../ProfileButton/ProfileButton";
import Sidebar from "./Sidebar/Sidebar";

const Navbar = ({ backTarget }) => {
	const [showSideBar, setShowSideBar] = useState(false);

	return (
		<div className="Navbar flex justify-between">
			<Sidebar className={showSideBar ? "w-2/3 flex" : "w-0 hidden"} />
			{showSideBar && <BackDrop onClick={() => setShowSideBar(false)} />}

			<BackButton target={backTarget} />
			<div className="flex">
				<OptionsButton />
				<ProfileButton onClick={() => setShowSideBar(true)} />
			</div>
		</div>
	);
};

export default Navbar;
